import { Tabs } from 'antd';
import styled from 'styled-components';

export const TabsContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Container = styled.div`
  margin: 1rem auto 3rem auto;
  max-width: ${({ theme }) => theme.breakpoints.laptopL};

  & > .ant-tabs {
    & > .ant-tabs-nav {
      padding-left: 1rem;
      margin-bottom: 0;

      & > .ant-tabs-nav-wrap > .ant-tabs-nav-list {
        width: ${({ theme }) => theme.breakpoints.laptopL};
        margin: auto;
      }
    }
  }
`;

export const ProjectsAndMockupsTabs = styled(Tabs)`
  & div.ant-tabs-nav {
    margin: 0;
  }
`;
